<template>
  <fieldset class="flex flex-col gap-2 border-none p-0 m-0">
    <legend v-if="label" class="text-sm font-medium text-fg mb-1 p-0">{{ label }}</legend>
    <div class="flex gap-2 flex-wrap">
      <button
        v-for="option in options"
        :key="String(option.value)"
        :class="[
          'flex-1 min-w-[120px] px-4 py-2 border-2 rounded-md cursor-pointer text-sm font-medium transition-all text-center',
          optionClasses(option.value),
        ]"
        type="button"
        @click="handleClick(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </fieldset>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: null
  },
  modelValue: {
    default: null
  },
  options: {
    type: Array,
    required: true,
    validator: (options) => {
      return options.every(opt =>
        opt &&
        typeof opt.label === 'string' &&
        (opt.value === true || opt.value === false || opt.value === null)
      )
    }
  },
  allowNull: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue'])

function optionClasses (value) {
  const isActive = props.modelValue === value;
  const isNull = props.modelValue === null && props.allowNull;
  if (isActive) {
    return 'bg-accent text-fg-on-accent border-accent font-semibold hover:bg-accent-emphasis hover:border-accent-emphasis';
  }
  if (isNull) {
    return 'border-border bg-surface text-fg-muted hover:border-accent hover:bg-muted hover:text-fg';
  }
  return 'border-border bg-surface text-fg hover:border-accent hover:bg-muted';
}

function handleClick (value) {
  if (props.allowNull && props.modelValue === value) {
    emit('update:modelValue', null)
  } else {
    emit('update:modelValue', value)
  }
}
</script>
